import { supabase } from "./supabase";
import { fromDbProject, toDbProjectUpdate } from "../lib/mappers";

const listProjects = async () => {
  const { data, error } = await supabase
    .from("projects")
    .select("id, title, updated_at")
    .order("updated_at", { ascending: false });

  if (error) throw error;
  return data ?? [];
};

const getProject = async (projectId) => {
  const { data, error } = await supabase
    .from("projects")
    .select("id, title, customer, start_at, disconnect_location, connect_location, rig, vessel, logo_url")
    .eq("id", projectId)
    .single();

  if (error) throw error;
  return fromDbProject(data);
};

const createProject = async ({ title, userId }) => {
  const { data, error } = await supabase
    .from("projects")
    .insert({ title, user_id: userId })
    .select("id, title, customer, start_at, disconnect_location, connect_location, rig, vessel, logo_url")
    .single();

  if (error) throw error;
  return fromDbProject(data);
};

const updateProject = async (projectId, project) => {
  const payload = toDbProjectUpdate(project);
  const { data, error } = await supabase
    .from("projects")
    .update(payload)
    .eq("id", projectId)
    .select("id, title, customer, start_at, disconnect_location, connect_location, rig, vessel, logo_url")
    .single();

  if (error) throw error;
  return fromDbProject(data);
};

const deleteProject = async (projectId) => {
  const { error } = await supabase.from("projects").delete().eq("id", projectId);
  if (error) throw error;
};

export { listProjects, getProject, createProject, updateProject, deleteProject };
